<template>
    <div id="addStaff">
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">View Inquiry</div> 
                    <a href="javascript:void(0)" v-on:click="backToList()" class="btn btn-secondary pull-right"> <i class="fp-back"> </i> Back</a>
                </div>
                <div class="container-fluid">
                    <!--page content-->
                    <div class="admin-page-content view-enquiry">
                        <section class="internal-container border-top-table-fl">
                            <div role="tabpanel" class="message-chat-container" id="message">                                   
                                <div class="subject-title">{{enqSubject}}</div>
                                <div class="message-chat-internal-container p-4">
                                    <div class="truck-type">{{truckType}}</div>
                                    <div class="msg-chat-container mt-4 overflow-hidden">
                                        <div class="admin-chat overflow-hidden">
                                            <img src="/static/images/default.jpg" alt="Velocity Truck Rental &amp; Leasing">
                                            <div class="admin-chat-block">
                                                <p>{{enquiry}}</p>
                                                <div class="chat-info"> <strong class="font-bold">{{enqContact}}</strong> | {{timestamp}}</div>
                                            </div>
                                        </div>
                                        <template v-for="(responses,key) in responseArr">
                                            <div :key="key" class="admin-chat overflow-hidden" v-if="responses.type != 'user'">
                                                <img src="/static/images/default.jpg " alt="Velocity Truck Rental &amp; Leasing">
                                                <div class="admin-chat-block">
                                                    <p>{{responses.reply}}</p>
                                                    <div class="chat-info"> <strong class="font-bold">{{responses.contact}}</strong> | {{responses.timestamp}}</div>
                                                </div>
                                            </div>
                                            <div :key="key" class="customer-chat overflow-hidden" v-if="responses.type == 'user'">
                                                <div class="customer-chat-block text-right">
                                                    <img src="/static/images/girl.png" alt="Velocity Truck Rental &amp; Leasing">
                                                    <p>{{responses.reply}}</p>
                                                    <span> <strong class="font-bold">{{responses.contact}}</strong> | {{responses.timestamp}}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="form-group overflow-hidden answer-section">
                                        <label class="control-label" for="exampleFormControlTextarea2">Answer</label>
                                        <textarea class="form-control rounded-0" v-model="response" id="exampleFormControlTextarea2" rows="3" v-on:keyup="process($event)"></textarea>
                                    </div>
                                    <button type="submit" v-on:click="storeResponse()" class="btn btn-primary" ><i class="fp-send-message"> </i> {{replyBtn}}</button>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>            
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>    
</template>

<script>
    import Vue from "vue";
    // import EventBus from ".././event-bus";
    // import { headers } from "../config";
    
    import {commonMixins} from '../../mixins/commonMixins';

    

    export default {
        name: "viewBooking",
        mixins:[commonMixins],
        data: () => ({
        view_enquiry_id: 0,
        enquiry:"",
        response:"",
        enquiryAns:"",
        responseArr:[],
        timestamp:"",
        errorMsg:"",
        truckType:"",
        replyBtn:"Send",
        enqSubject:"",
        enqContact:"",
        userId:0,
        reply:"",
        permissions:[],
        cantAccessPage:"",
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_enquiry') {
                    self.cantAccessPage = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function () {
        var self = this;

        //check that page is add or update
        self.view_enquiry_id = self.$route.params.id;

        //check user loggged in or not
        var userObj = localStorage.getItem("user_obj");
        var role = null;

        //if user logged in than remove login button and registration button
        if (userObj != null) {
            var userJson = JSON.parse(userObj);
            if (userJson.roles.length > 0) {
                role = userJson.roles[0].name;

            }
            self.userId = userJson.id;
            // EventBus.$emit("logged-in", false, userJson["contact"], role); //
        }
        self.role = userJson.roles[0].name;
        //set the page is not profile page
        // EventBus.$emit("profile", false); //

        if (self.view_enquiry_id != undefined) {

            $.ajax({
                url: process.env.ROOT_API + "/enquiry/list",
                type: "GET",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,
                data: {
                    enquiry_id: self.view_enquiry_id,
                },
                success: function(data) {
                    if (data.status == "success") {
                        console.log(data.content);
                        self.enquiry = data.content.enquiry;
                        self.timestamp = data.content.timestamp;
                        self.enquiryAns = data.content.reply;
                        self.truckType = data.content.truck_type;
                        self.enqSubject = data.content.subject;
                        self.enqContact = data.content.contact;
                    }

                },
                error: function(jqXHR, exception) {
                    $("#myModal").modal("hide");
                    self.generateStatusCodeMessage(jqXHR, true, 'get-enquiry-view-list')
                }
            });
            self.getResponses();
            self.getPermissions();
        }
    },
    methods:{
            //reply of enquiries with enter key press
        process: function (e ) {
            var code = (e.keyCode ? e.keyCode : e.which);
            if (code === 13) { //Enter keycode
                this.storeResponse();
            }
        },
        storeResponse: function(){

            var self = this;
            self.replyBtn = "Sending ...";
            var response = self.response;

            if( !self.response ) {
                self.errorMsg = 'Response Required';
                self.replyBtn = "Send";
            } else {
                
                self.errorMsg = "";
                $.ajax({
                    // url: process.env.API + "/" + process.env.VERSION + "/store_enquiry",
                    url: process.env.ROOT_API + "/enquiry/store",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data: {
                        enquiry: response,
                        enquiry_id: self.view_enquiry_id,

                    },
                    dataType: "json",
                    success: function (data) {
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            self.response = "";
                            self.reply = data.content;
                            self.replyBtn = "Send";
                            // self.responseArr.push(self.reply);
                            self.getResponses();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR, true, 'store-enquiry-data')
                    }
                });
            }
        },
        getResponses: function(){
            var self = this;

            $.ajax({
                // url: process.env.API + "/" + process.env.VERSION + "/get_enquiry_response",
                url: process.env.ROOT_API + "/get-enquiry",
                type: "GET",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,
                data:{
                    enquiry_id: self.view_enquiry_id,
                    flag:'admin'
                },
                success: function(data) {

                    if (data.status == "success") {
                        self.responseArr = data.content;
                        // console.log(data.content);
                    }
                },
                error: function(jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR, true, 'get-enquiry-view')
                }
            });

        },
        backToList: function(){
            var self = this;

            self.$router.push("/inquiry/list");
        }
    }
    };

</script>


// WEBPACK FOOTER //
// src/components/Enquiries/ViewEnquiry.vue